<y42-job-logs [eventId]="data.eventId" [sideNavTemplate]="data.sideNavTemplate" (closeDialog)="cancel()"></y42-job-logs>
